import ListItem, { ListItemProps } from '../ListItem';
import { styled } from '@mui/material/styles';
import { forwardRef, ReactElement, ReactNode } from 'react';
import SidebarMenuItemIcon from '../SidebarMenuItemIcon';
import SidebarMenuItemText from '../SidebarMenuItemText';
import colors from '../theme/colors';

const StyledMenuItem = styled(ListItem)(({ theme }) => ({
  '&:hover': {
    background: `${colors.brandPrimary['100']}`,
  },
  '&.Mui-selected': {
    background: `${theme.palette.common.white}`,
    color: `${theme.palette.primary.main}`,
    '& .MuiSvgIcon-root': {
      color: `${theme.palette.primary.main}`,
    },
  },
  '&.Mui-selected:hover': {
    background: `${colors.brandPrimary['100']}`,
  },
  [theme.breakpoints.between('md', 'xl')]: {
    flexDirection: 'column',
    textAlign: 'center',
  },
}));

export interface SidebarMenuItemProps extends ListItemProps {
  children: ReactNode;
  icon?: ReactElement;
}

const SidebarMenuItem = forwardRef<HTMLLIElement, SidebarMenuItemProps | any>((props, ref) => {
  const { children, icon, ...otherProps } = props;

  return (
    <StyledMenuItem ref={ref} {...otherProps}>
      <SidebarMenuItemIcon>{icon}</SidebarMenuItemIcon>
      <SidebarMenuItemText primary={children} />
    </StyledMenuItem>
  );
});

SidebarMenuItem.displayName = 'SidebarMenuItem';

export default SidebarMenuItem;
